<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div class="RPBarChartCard__header-bar">
                <div class="RPBarChartCard__header">
                    <slot name="header">
                        <span class="RPBarChartCard__header-text">{{ header }}</span>
                        <RPTooltip
                            v-if="headerTooltip !== ''"
                            class="RPBarChartCard__header-tooltip"
                            :tooltip="headerTooltip"
                        />
                    </slot>
                </div>
                <div class="RPBarChartCard__title-action">
                    <slot name="action"></slot>
                </div>
            </div>
            <div class="RPBarChartCard__chart-container">
                <ApexCharts
                    type="bar"
                    :series="series"
                    :options="options"
                    height="100%"
                />
            </div>
        </template>
    </div>
</template>
<script>
import RPTooltip from 'components/Basic/Misc/RPTooltip.vue';
import ApexCharts from 'vue-apexcharts';
import colors from 'style/_colors.scss';
import has from 'lodash/has';
import getRandomColor from '../getRandomColor';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPBarChartCard',
    components: {
        RPTooltip,
        ApexCharts
    },
    props: {
        header: {
            type: String,
            required: true
        },
        headerTooltip: {
            type: String,
            default: ''
        },
        chartData: {
            type: Array,
            required: true,
        },
        xAxisLabel: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('RPBarChartCard', this.status);
        },
        series(){
            return [{
                data: this.chartData.map(d => d.count)
            }];
        },
        options(){
            return {
                legend: {
                    show: false,
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    animations: {
                        enabled: false
                    },
                },
                grid: {
                    show: false,
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    colors: this.chartData.map(d => has(d, 'color') ? d.color : getRandomColor(JSON.stringify(d))),
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                        horizontal: true,
                        endingShape: 'rounded',
                        barHeight: '35%',
                    }
                },
                xaxis: {
                    axisTicks: {
                        show: false,
                    },
                    categories: this.chartData.map(d => d.category),
                    title: {
                        offsetX: 0,
                        offsetY: 16,
                        text: this.xAxisLabel,
                        style: {
                            fontSize: '.85rem',
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 'normal',
                            fontColor: colors.textGrey,
                        },
                    }
                }
            };
        }
    },
};
</script>
<style lang="scss">
    .RPBarChartCard {
        position: relative;
        min-width: 18.75rem;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        padding: 1rem;
        background: $white;

        @include loading(100%, 100%);

        &__header-bar {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
        }
        &__header {
            display: flex;
            align-items: center;
            flex-grow: 1;
        }
        &__header-text {
            color: $text-dark;
            font-weight: 600;
        }
        &__header-tooltip {
            margin-left: 0.25rem;
        }
        &__chart-container {
            position:absolute;
            bottom: 1rem;
            top: 3rem;
            left: 1rem;
            right: 1rem;
        }
    }
</style>
